import React from 'react';

export const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/Logo.png?v=2`;

/**
 * Success Bridge Academy brand mark from public/Logo.png
 */
export default function BrandLogo({ size = 44, className = '', alt = 'Success Bridge Academy' }) {
  return (
    <img
      src={LOGO_SRC}
      alt={alt}
      className={`sba-brand-logo${className ? ` ${className}` : ''}`}
      width={size}
      height={size}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        objectFit: 'contain',
        background: 'transparent',
      }}
    />
  );
}
